<template>
  <div class="tab__box">
    <el-tag
      v-for="(item, index) in historyList"
      :key="index"
      closable
      size="mini"
      :type="item.type"
      @close="handleClose(index)"
      @click="goPage(item.name,item.params)"
      class="tag__item"
    >{{item.title}}</el-tag>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data() {
    return {
      arr: []
    }
  },
  computed: {
    historyList() {
      let _canPush = true
      const _history = JSON.parse(this.$store.state.history.history)
      this.arr.forEach(i => {
        if (i.name === _history.name) _canPush = false
        if (i.name === this.$route.name) i.type = ''
        else i.type = 'info'
      })
      if (_canPush) this.arr.push(_history)
      return this.arr
    }
  },
  methods: {
    handleClose(index) {
      this.arr.splice(index, 1)
    },
    goPage(name, query) {
      this.$router.push({ name, query })
    },
  }
}
</script>

<style scoped>
.tab__box {
  padding: 10px 20px 0 10px;
  cursor: pointer;
}
.tag__item {
  margin-right: 10px;
  margin-bottom: 10px;
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/history.vue